import { useLocation, useNavigate } from "react-router-dom"

import { NavigationSectionModel } from "@models/navigations"

import { SidebarGroup, SidebarGroupLabel, SidebarMenu, SidebarMenuButton, SidebarMenuItem } from "@ui/sidebar"

interface NavigationSectionProps {
    section: NavigationSectionModel
}
export function NavigationSection({ section }: Readonly<NavigationSectionProps>) {
    const location = useLocation()
    const navigate = useNavigate()

    const handleNavigate = (url: string) => {
        if (window.location.hash) {
            window.history.pushState(null, "", url)
            window.location.reload()
        } else {
            navigate(url)
        }
    }

    return (
        <SidebarGroup>
            <SidebarGroupLabel>{section.title}</SidebarGroupLabel>
            <SidebarMenu>
                {section.items.map((item) => (
                    <SidebarMenuItem key={item.title} className={`${location.pathname === item.url ? "rounded-md bg-gray-200" : ""}`}>
                        <SidebarMenuButton asChild tooltip={item.tooltip} onClick={() => handleNavigate(item.url)} className="hover:cursor-pointer">
                            <div>
                                <item.icon />
                                <span>{item.title}</span>
                            </div>
                        </SidebarMenuButton>
                    </SidebarMenuItem>
                ))}
            </SidebarMenu>
        </SidebarGroup>
    )
}
